// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const salazzle: PokeData = {
  "id": 758,
  "name": "salazzle",
  "height": 12,
  "weight": 222,
  "base_experience": 168,
  "types": [
    PokeType.POISON,
    PokeType.FIRE
  ],
  "api_moves": [
    "pound",
    "double-slap",
    "scratch",
    "disable",
    "ember",
    "flamethrower",
    "dragon-rage",
    "toxic",
    "smog",
    "poison-gas",
    "swagger",
    "encore",
    "sweet-scent",
    "torment",
    "knock-off",
    "endeavor",
    "poison-fang",
    "dragon-pulse",
    "nasty-plot",
    "captivate",
    "venoshock",
    "flame-burst",
    "incinerate",
    "venom-drench",
    "fire-lash"
  ],
  "moves": [
    "scratch",
    "ember",
    "flamethrower",
    "poison-gas",
    "poison-fang",
    "dragon-pulse",
    "venom-drench",
    "flare-blitz",
    "toxic-overload",
    "purify",
    "fire-fang",
    "toxic-spikes",
    "acid"
  ],
  "evolution_chain": {
    "id": 390,
    "item": null,
    "species": [
      {
        "name": "salandit",
        "order": 757,
        "types": [
          PokeType.POISON,
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "salazzle",
        "order": 758,
        "types": [
          PokeType.POISON,
          PokeType.FIRE
        ],
        "evolves_from_species_id": 757,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 33,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": {
              "name": "female"
            }
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 88,
    "speed": 160,
    "ability_power": 152
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
